enum SenderType {
  Socket,
  Beacon,
}

export default SenderType;
